/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';

const state = {
  service_order_types: [],
  limit_os: 50,
  service_order_count: 0
};

const getters = {
  service_order_types: (state) => state.service_order_types,
  limit_os: (state) => state.limit_os,
  service_order_count: (state) => state.service_order_count
};

const mutations = {
  SET_SERVICE_ORDER_TYPES(state, serviceOrderTypes) {
    state.service_order_types = serviceOrderTypes;
  },
  SET_LIMIT_OS(state, limitOs) {
    state.limit_os = limitOs;
  },
  SET_SERVICE_ORDER_COUNT(state, serviceOrderCount) {
    state.service_order_count = serviceOrderCount;
  },
  INCREASE_SERVICE_ORDER_COUNT(state, value) {
    state.service_order_count += value;
  }
};

const actions = {
  getServiceInformation({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .get('/service_order_types')
        .then((response) => {
          commit('SET_SERVICE_ORDER_TYPES', response.data.service_order_types);

          if (response.data.organization_signature) {
            if (response.data.organization_signature.plan_signature) {
              commit('SET_LIMIT_OS', response.data.organization_signature.plan_signature.limit_os);
            }
            commit('SET_SERVICE_ORDER_COUNT', response.data.organization_signature.service_order_count);
          }

          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
